import { create } from 'zustand';

interface QuickSearchState {
    hide: boolean;
    visualSearchActive: boolean;
    hideQuickSearch: (bool: boolean) => void;
    setVisualSearchActive: (bool: boolean) => void;
}

export const useQuickSearchStore = create<QuickSearchState>((set) => ({
    hide: false,
    visualSearchActive: true,
    hideQuickSearch: (bool) => set({ hide: bool }),
    setVisualSearchActive: (bool) => set({ visualSearchActive: bool })
}));
